export class ValidationError extends Error {
  source = null;
  validity = null;
  // message = null;
  constructor(s, v, vm, ...params) {
    super(...params);

    if (s instanceof HTMLElement) {
      [s, v, vm] = [s.name, s.validity, s.validationMessage];
    }

    this.source = s;
    this.validity = v;
    this.message = vm;
    this.name = 'Validation Error';
    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ValidationError);
    }
  }

  toString() {
    let s = this.source;
    if (!s) {
      s = this.name;
    }
    if (!this.message) {
      return s;
    }
    return `${s}: ${this.message}`;
  }
}
